import type { SVGProps } from 'react';

const SvgNavigationMobilePush = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" {...props}>
    <g fill={props.color}>
      <path
        fillRule="evenodd"
        d="M10.684 0a3.316 3.316 0 1 0 0 6.632 3.316 3.316 0 0 0 0-6.632zM8.842 3.316a1.842 1.842 0 1 1 3.684 0 1.842 1.842 0 0 1-3.684 0z"
        clipRule="evenodd"
      />
      <path d="M2.947 2.21h3.076c.125-.53.339-1.027.625-1.473h-3.7A2.947 2.947 0 0 0 0 3.684v7.369A2.947 2.947 0 0 0 2.947 14h7.369a2.947 2.947 0 0 0 2.947-2.947v-3.7c-.446.285-.943.499-1.474.624v3.076c0 .813-.66 1.473-1.473 1.473H2.947c-.814 0-1.473-.66-1.473-1.473V3.684c0-.814.66-1.473 1.473-1.473z" />
    </g>
  </svg>
);

export default SvgNavigationMobilePush;
